var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[_c('aha-icon',{attrs:{"name":"timer","width":"28","height":"28","viewBox":"0 0 24 24"}}),_c('span',{ref:"timeToAnswer",staticClass:"ml-2 mr-3 min-w-16"}),_c('span',{staticClass:"countdown-toggler"},[_c('font-awesome-icon',{staticClass:"text-xs",attrs:{"icon":"plus"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }